"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.headerCase = void 0;
var tslib_1 = require("tslib");
var capital_case_1 = require("capital-case");
function headerCase(input, options) {
    if (options === void 0) { options = {}; }
    return capital_case_1.capitalCase(input, tslib_1.__assign({ delimiter: "-" }, options));
}
exports.headerCase = headerCase;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/header-case/dist/index.js
// module id = 1236
// module chunks = 0